import React from 'react';
import { cn } from '../../utils/cn';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ invalid, className, ...rest }, ref) => (
    <textarea
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'min-h-[6rem] w-full rounded-control bg-card border border-line-strong text-ink placeholder:text-muted px-3 py-2 text-base',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand disabled:opacity-50 disabled:cursor-not-allowed',
        invalid && 'border-danger-text',
        className
      )}
      {...rest}
    />
  )
);
Textarea.displayName = 'Textarea';
